$(function () {
    // about witness swiper
    var abWitnessSwiper = new Swiper('.ab-witness-swiper', {
        slidesPerView: 1,
        centeredSlides: true,
        initialSlide: 0,
        spaceBetween: 0,
        effect: 'coverflow',
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 280,
            modifier: 2,
            slideShadows: false,
        },
        navigation: {
            nextEl: '.ab-witness-arrow-right',
            prevEl: '.ab-witness-arrow-left',
        },
        // pagination: {
        //     el: '.ab-witness-pagination',
        //     clickable: true,
        //     bulletClass: 'swiper-pagination-bullet',
        //     bulletActiveClass: 'swiper-pagination-bullet-active',
        // },
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
        breakpoints: {
            769: {
                slidesPerView: 1.2,
            },
            1200: {
                slidesPerView: 1.5,
            }
        },
        on: {
            init: function () {
                updateAbWitnessPagination(this);
            },
            slideChange: function () {
                updateAbWitnessPagination(this);
            }
        }
    });

    // 左右箭頭點擊
    // $(".ab-witness-arrow-left").on("click", function(){
    //     abWitnessSwiper.slidePrev();
    // });
    // $(".ab-witness-arrow-right").on("click", function(){
    //     abWitnessSwiper.slideNext();
    // });

    // 分頁數字同步
    function updateAbWitnessPagination(swiper) {
        var total = swiper.slides.length;
        var realIndex = swiper.realIndex !== undefined ? swiper.realIndex : swiper.activeIndex;
        var current = realIndex + 1;
        var $pagination = $(".ab-witness-pagination-numbers");
        $pagination.find(".current").text(current.toString().padStart(2, '0'));
        $pagination.find(".total").text(total.toString().padStart(2, '0'));

        $('.rd-history').hide().eq(current-1).show()
    }

    // 只在初始化時補一次
    setTimeout(function() {
        abWitnessSwiper.update();
        abWitnessSwiper.slideToLoop(0, 0, false);
    }, 100);

    // 等所有圖片載入完畢後再 update
    var $imgs = $('.ab_witness_bnimg');
    var loadedCount = 0;
    $imgs.each(function() {
        if (this.complete) {
            loadedCount++;
        } else {
            $(this).on('load error', function() {
                loadedCount++;
                if (loadedCount === $imgs.length) {
                    abWitnessSwiper.update();
                }
            });
        }
    });
    // 如果一開始就全部載入完畢
    if (loadedCount === $imgs.length) {
        abWitnessSwiper.update();
    }

    if ($("#rd-section-ab1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ab1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ab1").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-ab2").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ab2",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ab2").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-ab3").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ab3",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ab3").addClass("ani1_do").removeClass("op0");
            },
        });

        // let itemElements = $(".rd_development_item");
        // $(window).on("scroll", function () {
        //     let closestItem = findClosestItem();
        //     itemElements.removeClass("now");
        //     closestItem.addClass("now");
        //
        //     $("#rd_development_item_img").css({
        //         background:
        //             "url(" + closestItem.data("img") + ") no-repeat center",
        //         "background-size": "cover",
        //     });
        // });

        function findClosestItem() {
            let closestItem = null;
            let closestDistance = Infinity;
            let windowCenter = $(window).scrollTop() + $(window).height() / 2;

            itemElements.each(function () {
                let distance = Math.abs($(this).offset().top - windowCenter);
                if (distance < closestDistance) {
                    closestItem = $(this);
                    closestDistance = distance;
                }
            });

            return closestItem;
        }
    }
    if ($("#rd-section-ab4").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ab4",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ab4").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-ab5").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ab5",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ab5").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-ab6").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ab6",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ab6").addClass("ani_do").removeClass("op0");
            },
        });
    }

    let developmentHistorySwiper = new Swiper(".swiper_history", {
        navigation: {
            nextEl: ".sw_right",
            prevEl: ".sw_left",
        },
        on: {
            reachBeginning: function () {
                $("#rd_development_history_left").addClass("gray");
                $("#rd_development_history_right").removeClass("gray");
            },
            slideChange: function () {
                let currentIndex = this.activeIndex;
                if (currentIndex > 0) {
                    $("#rd_development_history_left").removeClass("gray");
                }
                if (currentIndex < this.slides.length - 1) {
                    $("#rd_development_history_right").removeClass("gray");
                }

                pcDevelopmentHistoryYearSwiper.slideTo(
                    Math.ceil((currentIndex + 1) / 5) - 1
                );

                mbDevelopmentHistoryYearSwiper.slideTo(
                    Math.ceil((currentIndex + 1) / 4) - 1
                );

                developmentHistoryYearLineBar(currentIndex);
            },
            reachEnd: function () {
                $("#rd_development_history_left").removeClass("gray");
                $("#rd_development_history_right").addClass("gray");
            },
        },
    });

    let pcDevelopmentHistoryYearSwiper = new Swiper(
        "#rd_pc_development_history_year_swiper",
        {
            navigation: {
                nextEl: "#rd_pc_development_history_year_bar_right",
                prevEl: "#rd_pc_development_history_year_bar_left",
            },
            on: {
                reachBeginning: function () {
                    $("#rd_pc_development_history_year_bar_left").addClass(
                        "click_x"
                    );
                    $("#rd_pc_development_history_year_bar_right").removeClass(
                        "click_x"
                    );
                },
                slideChange: function () {
                    let currentIndex = this.activeIndex;
                    if (currentIndex > 0) {
                        $(
                            "#rd_pc_development_history_year_bar_left"
                        ).removeClass("click_x");
                    }
                    if (currentIndex < this.slides.length - 1) {
                        $(
                            "#rd_pc_development_history_year_bar_right"
                        ).removeClass("click_x");
                    }
                },
                slideChangeTransitionEnd: function () {
                    let currentIndex = this.activeIndex;
                    let index = $(
                        "#rd_pc_development_history_year_swiper .rd_development_history_year.now"
                    ).data("index");
                    if (currentIndex < Math.ceil((index + 1) / 5) - 1) {
                        let t = $(
                            "#rd_pc_development_history_year_swiper .swiper-slide-active .rd_development_history_year:last"
                        );
                        let x = $(
                            "#rd_pc_development_history_year_swiper .swiper-slide-active"
                        ).width();
                        xAxis(t, x);
                    }
                },
                reachEnd: function () {
                    $("#rd_pc_development_history_year_bar_left").removeClass(
                        "click_x"
                    );
                    $("#rd_pc_development_history_year_bar_right").addClass(
                        "click_x"
                    );
                },
            },
        }
    );

    let mbDevelopmentHistoryYearSwiper = new Swiper(
        "#rd_mb_development_history_year_swiper",
        {
            navigation: {
                nextEl: "#rd_mb_development_history_year_bar_right",
                prevEl: "#rd_mb_development_history_year_bar_left",
            },
            on: {
                reachBeginning: function () {
                    $("#rd_mb_development_history_year_bar_left").addClass(
                        "click_x"
                    );
                    $("#rd_mb_development_history_year_bar_right").removeClass(
                        "click_x"
                    );
                },
                slideChange: function () {
                    let currentIndex = this.activeIndex;
                    if (currentIndex > 0) {
                        $(
                            "#rd_mb_development_history_year_bar_left"
                        ).removeClass("click_x");
                    }
                    if (currentIndex < this.slides.length - 1) {
                        $(
                            "#rd_mb_development_history_year_bar_right"
                        ).removeClass("click_x");
                    }
                },
                slideChangeTransitionEnd: function () {
                    let currentIndex = this.activeIndex;
                    let index = $(
                        "#rd_mb_development_history_year_swiper .rd_development_history_year.now"
                    ).data("index");
                    if (currentIndex < Math.ceil((index + 1) / 4) - 1) {
                        let t = $(
                            "#rd_mb_development_history_year_swiper .swiper-slide-active .rd_development_history_year:last"
                        );
                        let x = $(
                            "#rd_mb_development_history_year_swiper .swiper-slide-active"
                        ).width();
                        xAxis(t, x);
                    }
                },
                reachEnd: function () {
                    $("#rd_mb_development_history_year_bar_left").removeClass(
                        "click_x"
                    );
                    $("#rd_mb_development_history_year_bar_right").addClass(
                        "click_x"
                    );
                },
            },
        }
    );

    $(".rd_development_history_year").on("click", function () {
        developmentHistorySwiper.slideTo($(this).data("index"));
    });

    $(window).on("resize", function (e) {
        $(`.rd_development_history_year.now`).each(function () {
            xAxis($(this));
        });
    });
});

function developmentHistoryYearLineBar(index) {
    $(".rd_development_history_year").removeClass("now");

    $(`.rd_development_history_year[data-index=${index}]`).each(function () {
        $(this).addClass("now");
        xAxis($(this));
    });
}

function xAxis(t, x = 0) {
    if (!x) {
        x =
            t.offset().left -
            t.closest(".rd_development_history_year_bar").offset().left +
            36;
    }

    t.closest(".rd_development_history_year_bar")
        .find(".rd_development_history_year_line")
        .css("width", x);
}
